const state = {
  pages: [],
  badge: { Questions: '' },
}

const getters = {
  pages: state => state.pages,
  badge: state => state.badge,
}

const mutations = {
  addPage: (state, page) => {
    state.pages.push(page)
  },
  removePageToName: (state, path) => {
    state.pages = state.pages.filter(item => item.path != path)
  },
  removeOtherPageToName: (state, path) => {
    state.pages = state.pages.filter(item => item.path == path)
  },
  setBadge: (state, badge) => {
    state.badge = { ...state.badge, ...badge }
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
